<template>
	<div>
		<div id="notesBlock">
			<div><textarea v-model="newNote"></textarea></div>
			<div><b-button variant="primary" @click="addNote()">Add Note</b-button></div>
			<div>
				<div v-for="note in notes" v-bind:key="note.id">
					<b-card title="" sub-title="">
						<b-card-text class="note-text">
							{{ note.text }}
						</b-card-text>
						<a href="#" class="card-link">Reply</a>
					</b-card>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:"NotesWidget",
	props:{
		projectID:String
	},
	mounted(){
		this.loadNotes();
	},
	data(){
		return {
			newNote:"",
			notes:[]
		}
	},
	methods:{
		async addNote(){
			let text=this.newNote;
			this.newNote="";
			await this.$API.apiPOST("/comments", {projectID:this.projectID, text:text}, true);
			this.loadNotes();
		},
		async loadNotes(){
			let response = await this.$API.apiGET("/comments?projectID="+this.projectID, true);
			this.notes = response.comments.sort((a,b)=>{
					return b.created - a.created;
				});
		}
	}
}
</script>
<style type="text/css" scoped>
.note-text{
    white-space: pre-line;
    text-align: left;
}
</style>